module.exports = __webpack_public_path__ + "images/SMS-fae399ac7bbc44310f1e8d9ca45f2645.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/screenshots/SMS.png
// module id = hQ6o
// module chunks = 0